import {
  QueryClient,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { addMapperNotes } from "../../../apis";
import { SearchApiParams, Venue, VenuePinType } from "../../../types";
import { useAtom } from "jotai";
import { tagVenueSearchParamsAtom } from "../tagging";
import { Storage } from "common/storage";

export function usePostAddMapperNotes() {
  const accessToken = Storage.getCurrentUserToken();
  const queryClient = useQueryClient();
  const [tagVenueSearchParam] = useAtom(tagVenueSearchParamsAtom);

  const { mutate, error, status, data } = useMutation({
    mutationFn: ({
      venueId,
      businessReportIssueAction,
      note,
      noteAreaType,
      noteAreaId,
      returnOnDate,
    }: {
      venueId: string;
      note: string;
      businessReportIssueAction: string;
      noteAreaType: string;
      noteAreaId?: string;
      returnOnDate?: string;
    }) => {
      return addMapperNotes(
        venueId,
        note,
        businessReportIssueAction,
        accessToken || "",
        noteAreaType,
        noteAreaId,
        returnOnDate,
      );
    },
    onSuccess: (_, { venueId, businessReportIssueAction }) => {
      queryClient.invalidateQueries({
        queryKey: ["loadVenueDetailsBySlug"],
        exact: false,
      });

      updateMapPin(
        venueId,
        queryClient,
        tagVenueSearchParam,
        false,
        businessReportIssueAction,
        accessToken || ""
      );
    },
  });

  return { mutate, error, status, data };
}

function updateMapPin(
  venueId: string,
  queryClient: QueryClient,
  venueSearchParams: SearchApiParams,
  isHome: boolean,
  businessReportIssueAction: string,
  accessToken: string
) {
  const data = queryClient.getQueryData([
    isHome ? "homePins" : "tagPins",
    venueSearchParams,
    accessToken,
  ]);
  if (!data) {
    return;
  }
  const { locations, accessibility_tags } = data as {
    locations: Venue[];
    accessibility_tags: any[];
  };
  const updatedLocation = locations.find(
    (l) => l.business.id.toString() === venueId
  );
  if (updatedLocation) {
    console.log(
      "Found update location in mapper notes",
      updatedLocation.name,
      businessReportIssueAction
    );
    if (
      businessReportIssueAction === "1" ||
      businessReportIssueAction === "2" ||
      businessReportIssueAction === "3"
    ) {
      //remove this location from the list
      queryClient.setQueryData(
        [isHome ? "homePins" : "tagPins", venueSearchParams, accessToken],
        {
          locations: locations.filter(
            (e) => e.business.id.toString() !== venueId
          ),
          accessibility_tags,
        }
      );
    } else if (businessReportIssueAction === "5") {
      //remove this location from the list
      queryClient.setQueryData(
        [isHome ? "homePins" : "tagPins", venueSearchParams, accessToken],
        {
          locations: locations.filter(
            (e) => e.business.id.toString() !== venueId
          ),
          accessibility_tags,
        }
      );
    } if (businessReportIssueAction === "8") {
      updatedLocation.isReturnToVenue = 1;
      updatedLocation.hasNotesForMappers = true;
      queryClient.setQueryData(
        [isHome ? "homePins" : "tagPins", venueSearchParams, accessToken],
        {
          locations: [
            ...locations.filter((e) => e.business.id.toString() !== venueId),
            updatedLocation,
          ],
          accessibility_tags,
        }
      );
    } else {
      updatedLocation.hasNotesForMappers = true;
      queryClient.setQueryData(
        [isHome ? "homePins" : "tagPins", venueSearchParams, accessToken],
        {
          locations: [
            ...locations.filter((e) => e.business.id.toString() !== venueId),
            updatedLocation,
          ],
          accessibility_tags,
        }
      );
    }
  }
}
